module.exports = __webpack_public_path__ + "static/media/vf_wskirt_core.a519c7d1.svg";